import { Backdrop, useTheme } from '@mui/material';

import { FC } from 'react';
import shallow from 'zustand/shallow';
import { useDimmedLayer } from '@/logic/state';

export const DimmedLayer: FC = () => {
  const theme = useTheme();

  const isDimmedLayerActive = useDimmedLayer(s => s.isDimmedLayerActive, shallow);

  return (
    isDimmedLayerActive && (
      <Backdrop
        open={isDimmedLayerActive}
        sx={{
          zIndex: theme.zIndex.tooltip + 1,
          backgroundColor: theme.palette.backdrop.dimmedBackgroundColor,
          backdropFilter: 'none',
        }}
      />
    )
  );
};
